import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormSwitchInput from '../general-input-form/FormSwitchInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  onDateChange,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='asset_name'
          name='asset_name'
          colSize='6'
          inputLabel='Asset Name'
          className='mb-3'
          placeholder='Enter asset name...'
          value={values.asset_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.asset_name}
          invalid={errors.asset_name}
        />
        <FormPrice
          id='asset_value'
          name='asset_value'
          colSize='3'
          inputLabel='Asset Value'
          placeholder='Enter asset value...'
          value={values.asset_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.asset_value}
          invalid={errors.asset_value}
        />
        <FormDatePicker 
          id='asset_register_date'
          name='asset_register_date'
          colSize='6'
          inputLabel='Asset Register Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.asset_register_date}
          feedbackInvalid={errors.asset_register_date}
          invalid={errors.asset_register_date}
        />
        <FormSwitchInput 
          id='is_cash'
          name='is_cash'
          colSize='6'
          inputLabel='Cash?'
          className='mb-3'
          handleSwitch={handleChange}
          value={values.is_cash}
          invalid={errors?.is_cash}
        />
        <FormTextAreaInput
          id='asset_description'
          name='asset_description'
          colSize='6'
          inputLabel='Asset Description'
          className='mb-3'
          placeholder='Enter asset description...'
          rows='6'
          value={values.asset_description}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.asset_description}
          invalid={errors?.asset_description}
        />
      </CRow>
    </>
  )
}

export default AppForm